import { render, staticRenderFns } from "./GoThanksCompleted.vue?vue&type=template&id=2768e5d7&scoped=true"
import script from "./GoThanksCompleted.vue?vue&type=script&lang=js"
export * from "./GoThanksCompleted.vue?vue&type=script&lang=js"
import style0 from "./GoThanksCompleted.vue?vue&type=style&index=0&id=2768e5d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768e5d7",
  null
  
)

export default component.exports